import { apiClient } from "@/api/client";
import type { ListQuery, Paginated } from "@/types/common";
import type { RideDetail, RideRow, RideStatus, ScheduledRideRow } from "@/types/domain";

/** Talks to apps/admin-service (rides.service.ts live/list/detail). */
export const ridesApi = {
  /** GET /admin/rides/live — every ride in an active lifecycle state, incl. live driver position. */
  getLive: () => apiClient.get<RideRow[]>("/admin/rides/live").then((r) => r.data),

  /** GET /admin/rides — page, limit, status, search, from, to, driverId, customerId. */
  list: (
    query: ListQuery & {
      status?: RideStatus;
      from?: string;
      to?: string;
      driverId?: string;
      customerId?: string;
    },
  ) => apiClient.get<Paginated<RideRow>>("/admin/rides", { params: query }).then((r) => r.data),

  /** GET /admin/rides/scheduled — upcoming booked-ahead rides, page/limit/from/to/assignment/search. */
  getScheduled: (
    query: ListQuery & {
      from?: string;
      to?: string;
      assignment?: "assigned" | "unassigned";
    },
  ) =>
    apiClient
      .get<Paginated<ScheduledRideRow>>("/admin/rides/scheduled", { params: query })
      .then((r) => r.data),

  /** GET /admin/rides/:id — full detail incl. payments, timeline, path. */
  getById: (id: string) => apiClient.get<RideDetail>(`/admin/rides/${id}`).then((r) => r.data),
};

/**
 * Refunds are issued against a payment record (apps/payment-service), not the
 * ride itself — pick the paymentId from RideDetail.payments[].
 */
export const paymentsApi = {
  refund: (paymentId: string, payload: { amount?: number; reason: string }) =>
    apiClient.post(`/payments/${paymentId}/refund`, payload).then((r) => r.data),
};
